import Shop from '@models/country/Shop';
import shopComparator from '@utils/sortComparators/shopComparator';

export function sortShops(shops: Shop[]) {
    return [...shops].sort(shopComparator);
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/store/modules/data/country/utils.ts